import { t } from 'i18next';
import { reportStateEnum, reportTypeEnum } from '../enums';

export const reportStateLabels: Record<number, string> = {
    [reportStateEnum.VALIDATED]: 'validation',
    [reportStateEnum.REPORTFILLED]: 'submitted',
    [reportStateEnum.REPORT]: 'report',
    [reportStateEnum.PLANNING]: 'planning',
    [reportStateEnum.NEEDS]: 'need',
};

export const getReportStateLabel = (state?: number): string => {
    return state !== undefined && reportStateLabels[state] ? t(reportStateLabels[state]) : '';
};

export const reportTypeLabels: Record<number, string> = {
    [reportTypeEnum.ABSENT]: 'absent',
    [reportTypeEnum.SITE]: 'present',
};

export const getReportTypeLabel = (state?: number): string => {
    return state !== undefined && reportTypeLabels[state] ? t(reportTypeLabels[state]) : '';
};
